import React from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDatabase, faLayerGroup, faTag,
  faServer//, faAsterisk, faChartPie, faList, faChartArea, faFileAlt, faProjectDiagram, faLongArrowAltUp, faEllipsisV
} from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';
// import Load from '../components/loadAction';
// import { convertDataForListView, getConvertedSize, getChartFilterData, getChartTypeForMonitorCharts, normalizeChartData, filterBoxPlotData } from "../utils/common_utils";
// import { getAttributeData } from "../utils/event_handling";
// import {
//   DQ_CHART_POINTS,
//   MIN_MAX_SCALE, REQUIRES_CONTRIBUTION_INSTEAD_OF_CHART, BUTTON_WAIT_TIME, DUPLICATE_METRIC
// } from "../utils/constant";
import Image from '../components/image';
// import Summary from "./summary";
import moment from "moment";
// import _ from 'lodash';
import { Scrollbars } from 'react-custom-scrollbars';
// import Dropdown from 'react-bootstrap/Dropdown';
import { getApi//, postUIlogs
} from "../utils/event_handling";
import {getTeamId,getUserId} from '../utils/common_utils' //getIconforMetrics
// import {normalizeChildDatasetName} from '../utils/attribute_name_utils'



let activeItem = {
  'Attribute': 'breadcrumb-item',
  'Dataset': 'breadcrumb-item',
  'Datasource': 'breadcrumb-item',
  'Environment': 'breadcrumb-item',

};

document.onkeydown = checkKey;
function checkKey(e) {
  e = e || window.event;
  let downClick = document.getElementById("down")
  if (downClick === null) {
    return
  }
  if (e.keyCode === 38) {
    // up arrow
    //document.getElementById("up").click();
    start("up");
  }
  else if (e.keyCode === 40) {
    // down arrow

    start("down");
    //document.getElementById("down").click();
  }

}

let funCallFlag;
function start(param) {
  if (funCallFlag !== "undefined") {
    clearInterval(funCallFlag);
  }
  if (param === "up") {

    // funCallFlag = setInterval(upButtonClick, BUTTON_WAIT_TIME);
  } else {
    // funCallFlag = setInterval(downButtonClick, BUTTON_WAIT_TIME);
  }

}

// function upButtonClick(e) {
//   document.getElementById("up").click();
//   clearInterval(funCallFlag);
// }

// function downButtonClick(e) {
//   document.getElementById("down").click();
//   clearInterval(funCallFlag);
// }


class PipelineLeftPanel extends React.Component {
  constructor(props, context) {
    super(props, context);
    
    // this.changeTab = this.changeTab.bind(this);
    // this.changeSource = this.changeSource.bind(this);
    // this.getChartFilterData = getChartFilterData.bind(this);
    // this.changeData = this.changeData.bind(this);
    // this.breadCrumbEvent = this.breadCrumbEvent.bind(this);
    // this.handleLoad = this.handleLoad.bind(this);
    // this.handleTreeViewButton = this.handleTreeViewButton.bind(this);
    // this.processDatasourceChart = this.processDatasourceChart.bind(this);
    // this.handleChange = this.handleChange.bind(this);
    // this.closeIcon = this.closeIcon.bind(this);
    // this.getAttributeData = getAttributeData.bind(this);
    // this.getEnvTableData = this.getEnvTableData.bind(this);
    // this.reset = this.reset.bind(this);
    // let initialSelection = this.props.initialSelection
    // let nestedData = this.props.nestedData
    let startDate = moment().subtract(30, 'days');
    let endDate = moment().endOf('day');
    this.getApi = getApi.bind(this);
    // this.buildNestedStructure = this.buildNestedStructure.bind(this);
    // this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.state = {
      activeTabKey: "chartView",
      businessRule: null,
      sectionName: "",
      dataType: null,
      outlier: null,
      envTableData: null,
      recencyData: 0,
      disableDown: false,
      disableUp: true,
      distributionData: null,
      profileData: null,
      datasetIds: [],
      startDate: startDate,
      endDate: endDate,
      newData: {},
      isTreeSearch: false,
      datasetRow: 0,
      duplicateRows: 0,
      isRedirect: this.props.isRedirect,
      isFetched: false,
      filteredData: null,
      datasourceCount: 0,
      // data: nestedData,
      filterSearch: "",
      subString: this.props.subString,
      lastRefresh: null,
      attributeCount: 0,
      datasetCount: 0,
      isSearchHappened: this.props.isSearchHappened,
      selectedDataSource: null,
      isChartChanged: false,
      driftOnMetricsChart: null,
      selectedData: [],
      isDataChanged: false,
      currentIndex: 0,
      highlightedType: "",
      highlightedId: null,
      showTreeView: false,
      metricsOptions: [],
      // envName: initialSelection.envName,
      // datasourceName: initialSelection.datasourceName,
      // datasetName: initialSelection.datasetName,
      // attributeName: initialSelection.attributeName,
      filteredValues: [],
      driftOnMetricsKey: null,
      showCustomCheckbox: this.props.showCustomCheckbox,
      isNodeHasActions: this.props.isNodeHasActions,
      showSearchFilter: this.props.showSearchFilter,
      data:this.props.integrations_data,
      isChecked:this.props.isChecked,
      handleCheckboxChange: this.props.handleCheckboxChange,
      arrowIndicator:this.props.arrowIndicator,
      newValue :this.props.newValue,
      oldValue :this.props.oldValue,
      leftSearchText:'',
      loading: true, // Initial loading state
      teamId:getTeamId(),
      userId:getUserId(),
      selectedEnvId : this.props.selectedEnvId,
      selectedWatchListId : this.props.selectedWatchListId,
      AllInterationsResponse:this.props.AllInterationsResponse
    }
  }
  changeTab(tab) {
    this.setState({ activeTabKey: tab });
  }
  handleLoad(value) {
    this.setState({ loadValue: value });
  }
  // findAverage(inputArr) {
  //   if (inputArr !== null && inputArr !== undefined) {
  //     return inputArr.reduce((a, b) => a + b) / inputArr.length;
  //   } else {
  //     return 0;
  //   }
  // }

  // getEnvTableData(envData, chartData) {
  //   let headers = ["Datasource Name", "Dataset Name", "Attribute Count", "Dataset Size", "Last Refreshed Time"];
  //   let finalOp = [];
  //   let datasourceData = Object.values(envData)
  //   for (let i = 0; i < datasourceData.length; i++) {
  //     let datasourceName = datasourceData[i]["title"]
  //     let datasetData = Object.values(datasourceData[i]["childNodes"])
  //     for (let j = 0; j < datasetData.length; j++) {
  //       let row = [];
  //       let d = datasetData[j];
  //       let datasetName = d["title"]
  //       let datasetId = d["id"]
  //       let lastRefreshData = chartData.issued_attributes[datasetId]
  //       let sizeData = this.props.dataModule.dataSize.filter(x => x.data_set_id === Number(datasetId))
  //       let dataSize = 0
  //       if (sizeData.length > 0) {
  //         dataSize = getConvertedSize(sizeData[0]["size"])
  //       }
  //       let lastRefresh = null
  //       if (lastRefreshData) {
  //         lastRefresh = Object.values(lastRefreshData)[0]["refresh_time"]
  //       }

  //       let attributeCount = Object.values(d["childNodes"]).length

  //       row.push({ "value": datasourceName, "type": "td" });
  //       row.push({ "value": datasetName, "type": "td" });
  //       row.push({ "value": attributeCount, "type": "td" });
  //       row.push({ "value": dataSize, "type": "td" });
  //       row.push({ "value": lastRefresh, "type": "td" });
  //       finalOp.push(row);
  //     }
  //   }
  //   let tableData = { "headers": headers, "data": finalOp };

  //   return tableData;

  // }
  // changeSource(metricName, stateKey, title) {
  //   let finalData = null
  //   let filteredData = null
  //   if (this.state.selectedData !== null && ["Dataset", "Attribute"].includes(this.state.sectionName)) {
  //     for (let row of this.state.selectedData) {
  //       if (row["name"] === metricName) {
  //         finalData = row;
  //         finalData['data_source_name'] = this.state.datasourceName;
  //         finalData["datasetName"] = this.state.datasetName;
  //         finalData['attribute_name'] = this.state.attributeName;
  //         finalData['error_percentage'] = this.findAverage().toFixed(2);
  //         if (finalData["name"] === "Data Drift") {
  //           finalData["boxPlotData"] = filterBoxPlotData(finalData["boxPlotData"])
  //         }
  //         filteredData = getChartFilterData(finalData, this.state.startDate, this.state.endDate)
  //         break;
  //       }
  //     }
  //   } else if (this.state.sectionName === "Datasource") {
  //     let dataFromProps = this.props.datasourceData[metricName]
  //     let data = _.cloneDeep(dataFromProps);
  //     let result = this.processDatasourceChart(data, this.state.selectedDataSource)
  //     finalData = result["finalData"]
  //     filteredData = result["filteredData"]

  //   }


  //   const metricKey = "attribute_" + metricName;
  //   this.setState({ driftOnMetricsChart: finalData, filteredData: filteredData, loadValue: false, driftOnMetricsKey: metricKey });
  // }
  componentDidMount() {
    setTimeout(() => {
        this.setState({ loading: false });
    }, 3000); // Show loader for 3 seconds

    //  this.props.getMetricsValueResponse(this.props.id,this.props.selectedWatchlistId);

}

//   componentDidUpdate(prevProps) {


// if (JSON.stringify(prevProps.AllInterationsResponse) !== JSON.stringify(this.props.AllInterationsResponse) && prevProps.selectedEnvId !== this.props.selectedEnvId && prevProps.metricsValueResponse !== this.props.metricsValueResponse ) {
  
//   this.setState({ AllInterationsResponse: this.props.AllInterationsResponse });
//   this.props.getMetricsValueResponse(this.props.id,this.props.selectedWatchlistId);
// }
// if (JSON.stringify(prevProps.AllInterationsResponse) !== JSON.stringify(this.props.AllInterationsResponse)) {  
//   this.setState({ AllInterationsResponse: this.props.AllInterationsResponse });
// }

//       if (
//         prevProps.arrowIndicator !== this.props.arrowIndicator ||
//         prevProps.newValue !== this.props.newValue ||
//         prevProps.oldValue !== this.props.oldValue
//       ) {
//       }
//     if (prevProps.nestedData !== this.props.nestedData) {
//       let initialSelection = this.props.initialSelection
//       let envId = initialSelection.envId
//       let datasourceId = initialSelection.datasourceId
//       let datasetId = initialSelection.datasetId
//       let duplicateRows = 0;
//       let attributeId = initialSelection.attributeId
//       let filteredValues = [];
//       let selectedData = []
//       let metricData = []
//       let metricsOptions = []
//       let chartData = this.props.metricData;
//       let sectionName = ""
//       let driftOnMetricsChart = null
//       let filteredData = null
//       let driftOnMetricsKey = null
//       let highlightedType = ""
//       let highlightedId = null
//       let prefix;
//       let datasetIds = []
//       let attributeCount = 0
//       let datasetCount = 0
//       let datasourceCount = 0
//       let nestedData = this.props.nestedData
//       let lastRefresh;
//       let datasetRow = 0;
//       let envTableData = null
//       let recencyData = 0


//       if (Object.keys(initialSelection).length !== 0) {
//         envId = initialSelection.envId
//         datasourceId = initialSelection.datasourceId
//         highlightedType = initialSelection.type
//         datasetId = initialSelection.datasetId
//         attributeId = initialSelection.attributeId
//         if (attributeId !== null && attributeId !== undefined) {
//           prefix = `${envId}.${datasourceId}.${datasetId}.${attributeId}`
//           metricData = Object.values(chartData.attribute_level_data[datasetId][attributeId])
//           sectionName = "Attribute"
//           this.setState({ isFetched: false });
//           this.getAttributeData(datasetId, initialSelection.attributeName);
//           highlightedId = attributeId
//         } else if (datasetId !== null && datasetId !== undefined) {
//           prefix = `${envId}.${datasourceId}.${datasetId}`;
//           metricData = Object.values(chartData.dataset_level_data[datasetId])
//           sectionName = "Dataset"
//           lastRefresh = Object.values(chartData.issued_attributes[datasetId])[0]["refresh_time"]
//           datasetIds = [datasetId]
//           highlightedId = datasetId
//           attributeCount = Object.values(nestedData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"]).length
//           let duplicateInfo = this.props.dataModule.info[datasourceId][prefix]
//           if (duplicateInfo !== undefined) {
//             let duplicateRowsList = duplicateInfo[`${DUPLICATE_METRIC}_duplicate_row`]
//             if (duplicateRowsList) {
//               duplicateRows = duplicateRowsList[duplicateRowsList.length - 1]
//             }

//           }
//         } else if (datasourceId !== null && datasourceId !== undefined) {
//           prefix = `${envId}.${datasourceId}`;
//           sectionName = "Datasource"
//           highlightedId = datasourceId
//           datasetIds = Object.keys(nestedData[envId]["childNodes"][datasourceId]["childNodes"])
//           datasetCount = datasetIds.length
//           for (const key of Object.keys(this.props.datasourceData)) {
//             if (key.includes("Data")) {
//               metricsOptions.push({ "label": key, "value": key })
//             }

//           }
//           if (metricsOptions.length > 0) {
//             let dataFromProps = this.props.datasourceData[metricsOptions[0].value]
//             let data = _.cloneDeep(dataFromProps);
//             let result = this.processDatasourceChart(data, datasourceId);
//             driftOnMetricsChart = result["finalData"]
//             filteredData = result["filteredData"]
//           }

//           let recencyInfo = this.props.dataModule.recencyDetails[datasourceId]
//           for (let value of Object.values(recencyInfo)) {
//             let recencyFiltered = value
//             let recencyList = recencyFiltered[`${DUPLICATE_METRIC}_time_value`]
//             let latestRecency = 0
//             if (recencyList) {
//               latestRecency = recencyList[recencyList.length - 1]
//             }
//             if (latestRecency > 30) {
//               recencyData = recencyData + 1
//             }
//           }
//           let duplicateInfo = this.props.dataModule.info[datasourceId]
//           for (let value of Object.values(duplicateInfo)) {
//             let duplicateFiltered = value
//             let duplicateRowsList = duplicateFiltered[`${DUPLICATE_METRIC}_duplicate_row`]
//             if (duplicateRowsList) {
//               duplicateRows = duplicateRowsList[duplicateRowsList.length - 1] + duplicateRows
//             }
//           }

//         } else {
//           prefix = `${envId}`;
//           sectionName = "Environment"
//           datasetCount = 0
//           highlightedId = envId
//           let total = nestedData[envId]["childNodes"]
//           datasourceCount = Object.keys(total).length
//           for (const value of Object.values(total)) {
//             datasetIds = datasetIds.concat(Object.keys(value["childNodes"]))
//             datasetCount = datasetCount + datasetIds.length

//           }
//           envTableData = this.getEnvTableData(nestedData[envId]["childNodes"], chartData)
//         }
//         metricData = convertDataForListView(metricData, initialSelection.datasetName, initialSelection.datasourceName)
//         for (let i = 0; i < metricData.length; i++) {
//           if (metricData[i]["name"] === "Row Count") {
//             datasetRow = metricData[i]["value"][metricData[i]["value"].length - 1]
//           }
//           //           if(metricData[i]["hasDrift"] === false) {
//           //             continue
//           //           }
//           selectedData.push(metricData[i]);
//           metricsOptions.push({ "label": metricData[i]["name"], "value": metricData[i]["name"] })
//         }
//         if (selectedData.length > 0) {
//           driftOnMetricsChart = selectedData[0]
//           filteredData = getChartFilterData(driftOnMetricsChart, this.state.startDate, this.state.endDate)
//           driftOnMetricsKey = sectionName + driftOnMetricsChart["name"]
//         }
//         filteredValues.push(prefix)

//       }
//       this.setState({
//         data: this.props.nestedData,
//         envName: initialSelection.envName,
//         datasourceName: initialSelection.datasourceName,
//         selectedDataSource: datasourceId,
//         lastRefresh: lastRefresh,
//         datasetRow: datasetRow,
//         duplicateRows: duplicateRows,
//         recencyData: recencyData,
//         subString: this.props.subString,
//         selectedData: selectedData,
//         driftOnMetricsChart: driftOnMetricsChart,
//         filteredData: filteredData,
//         sectionName: sectionName,
//         driftOnMetricsKey: driftOnMetricsKey,
//         metricsOptions: metricsOptions,
//         attributeCount: attributeCount,
//         datasourceCount: datasourceCount,
//         isTreeSearch: false,
//         envTableData: envTableData,
//         newData: {},
//         filterSearch: "",
//         datasetCount: datasetCount,
//         datasetIds: datasetIds,
//         highlightedId: highlightedId,
//         highlightedType: highlightedType,
//         isSearchHappened: this.props.isSearchHappened,
//         datasetName: initialSelection.datasetName,
//         isRedirect: this.props.isRedirect,
//         attributeName: initialSelection.attributeName,
//         filteredValues: filteredValues,
//         envId: envId,
//         datasetId: datasetId,
//         attributeId: attributeId,
//         isDataChanged: !this.state.isDataChanged,
        
//       })
//     }
//   }
  // getDefaultSelectedMetrics() {
  //   let selectedMetricOptions = [];
  //   if (this.state.metricsOptions.length > 0) {
  //     selectedMetricOptions = this.state.metricsOptions[0];
  //     return selectedMetricOptions;
  //   } else {
  //     return selectedMetricOptions;
  //   }
  // }

  // breadCrumbEvent(e) {
  //   let type = e.target.id
  //   if (this.state.highlightedType === type) {
  //     return
  //   }
  //   let envName = this.state.envName
  //   let datasourceName = this.state.datasourceName
  //   let datasetName = this.state.datasetName
  //   let attributeName = this.state.attributeName
  //   let envId = this.state.envId
  //   let datasourceId = this.state.selectedDataSource
  //   let datasetId = this.state.datasetId
  //   let attributeId = this.state.attributeId
  //   if (type === "Environment") {
  //     this.changeData(envName, "", "", "", envId, null,
  //       null, null, envId, type);
  //   } else if (type === "Datasource") {
  //     this.changeData(envName, datasourceName, "", "", envId, datasourceId,
  //       null, null, datasourceId, type);
  //   } else if (type === "Dataset") {
  //     this.changeData(envName, datasourceName, datasetName, "", envId, datasourceId,
  //       datasetId, null, datasetId, type);
  //   } else if (type === "Attribute") {
  //     this.changeData(envName, datasourceName, datasetName, attributeName, envId, datasourceId,
  //       datasetId, attributeId, attributeId, type);
  //   }




  // }



  // changeData(envName, datasourceName, datasetName, attributeName, envId, datasourceId,
  //   datasetId, attributeId, id, type,isOpen, currentIndex = null,title) {
      
  //     //Add condition only tree opens 
  //     if (!isOpen){
  //     this.props.renderchartView(envName, datasourceName, datasetName, attributeName, envId, datasourceId,
  //       datasetId, attributeId, id, type,currentIndex = null,title)
  //     }
  //   let filteredValues = [];
  //   let filteredData;
  //   let chartData = this.props.metricData;
  //   let driftOnMetricsChart = null
  //   let driftOnMetricsKey = null
  //   let selectedData = []
  //   let metricData = []
  //   let metricsOptions = []
  //   let prefix;
  //   let attributeCount;
  //   let datasetCount;
  //   let datasetIds = [];
  //   let envTableData = null
  //   let lastRefresh;
  //   let duplicateRows = 0;
  //   let recencyData = 0
  //   let datasourceCount;
  //   let sectionName = ""
  //   let originalData = _.cloneDeep(this.props.originalData);
  //   if (originalData[envId]) {
  //   if (attributeId !== null && attributeId !== undefined) {
  //     prefix = `${envId}.${datasourceId}.${datasetId}.${attributeId}`
  //     metricData = Object.values(chartData.attribute_level_data[datasetId][attributeId])
  //     sectionName = "Attribute"
  //     this.setState({ isFetched: false, distributionData: null });
  //     this.getAttributeData(datasetId, attributeName);
  //     originalData[envId]["isOpen"] = true
  //     originalData[envId]["childNodes"][datasourceId]["isOpen"] = true
  //     originalData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["isOpen"] = true
  //     originalData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"][attributeId]["isOpen"] = true
  //   } else if (datasetId !== null && datasetId !== undefined) {
  //     originalData[envId]["isOpen"] = true
  //     originalData[envId]["childNodes"][datasourceId]["isOpen"] = true
  //     originalData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["isOpen"] = true
  //     originalData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["isShow"] = true

  //     prefix = `${envId}.${datasourceId}.${datasetId}`;
  //     lastRefresh = Object.values(chartData.issued_attributes[datasetId])[0]["refresh_time"]
  //     metricData = Object.values(chartData.dataset_level_data[datasetId])
  //     sectionName = "Dataset"
  //     datasetIds = [datasetId]
  //     let duplicateInfo = this.props.dataModule.info[datasourceId][prefix]
  //     if (duplicateInfo !== undefined) {
  //       let duplicateRowsList = duplicateInfo[`${DUPLICATE_METRIC}_duplicate_row`]
  //       if (duplicateRowsList) {
  //         duplicateRows = duplicateRowsList[duplicateRowsList.length - 1]
  //       }

  //     }
  //     attributeCount = Object.values(originalData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"]).length
  //   } else if (datasourceId !== null && datasourceId !== undefined) {
  //     prefix = `${envId}.${datasourceId}`;
  //     sectionName = "Datasource"
  //     datasetIds = Object.keys(originalData[envId]["childNodes"][datasourceId]["childNodes"])
  //     datasetCount = datasetIds.length
  //     originalData[envId]["isOpen"] = true
  //     originalData[envId]["childNodes"][datasourceId]["isOpen"] = true
  //     originalData[envId]["childNodes"][datasourceId]["isShow"] = true
  //     for (const key of Object.keys(this.props.datasourceData)) {
  //       if (key.includes("Data")) {
  //         metricsOptions.push({ "label": key, "value": key })
  //       }

  //     }
  //     if (metricsOptions.length > 0) {
  //       let dataFromProps = this.props.datasourceData[metricsOptions[0].value]
  //       let data = _.cloneDeep(dataFromProps);
  //       let result = this.processDatasourceChart(data, datasourceId);
  //       driftOnMetricsChart = result["finalData"]
  //       filteredData = result["filteredData"]
  //     }

  //     let duplicateInfo = this.props.dataModule.info[datasourceId]
  //     for (let value of Object.values(duplicateInfo)) {
  //       let duplicateFiltered = value
  //       let duplicateRowsList = duplicateFiltered[`${DUPLICATE_METRIC}_duplicate_row`]
  //       if (duplicateRowsList) {
  //         duplicateRows = duplicateRowsList[duplicateRowsList.length - 1] + duplicateRows
  //       }
  //     }
  //     let recencyInfo = this.props.dataModule.recencyDetails[datasourceId]
  //     for (let value of Object.values(recencyInfo)) {
  //       let recencyFiltered = value
  //       let recencyList = recencyFiltered[`${DUPLICATE_METRIC}_time_value`]
  //       let latestRecency = 0
  //       if (recencyList) {
  //         latestRecency = recencyList[recencyList.length - 1]
  //       }
  //       if (latestRecency > 30) {
  //         recencyData = recencyData + 1
  //       }
  //     }

  //   } else {
  //     prefix = `${envId}`;
  //     sectionName = "Environment"
  //     datasetCount = 0
  //     let total = originalData[envId]["childNodes"]
  //     datasourceCount = Object.keys(total).length
  //     for (const value of Object.values(total)) {
  //       datasetIds = datasetIds.concat(Object.keys(value["childNodes"]))
  //       datasetCount = datasetCount + datasetIds.length
  //     }
  //     envTableData = this.getEnvTableData(originalData[envId]["childNodes"], chartData)
  //     originalData[envId]["isShow"] = true
  //     originalData[envId]["isOpen"] = true
  //   }}
  //   let datasetRow = 0;
  //   if (["Dataset", "Attribute"].includes(sectionName)) {
  //     metricData = convertDataForListView(metricData, datasetName, datasourceName)
  //     for (let i = 0; i < metricData.length; i++) {
  //       if (metricData[i]["name"] === "Row Count") {
  //         datasetRow = metricData[i]["value"][metricData[i]["value"].length - 1]
  //       }
  //       //               if(metricData[i]["hasDrift"] === false) {
  //       //                 continue
  //       //               }

  //       selectedData.push(metricData[i]);
  //       metricsOptions.push({ "label": metricData[i]["name"], "value": metricData[i]["name"] });
  //     }

  //   }

  //   if (selectedData.length > 0) {
  //     driftOnMetricsChart = selectedData[0]
  //     if (driftOnMetricsChart["name"] === "Data Drift") {
  //       driftOnMetricsChart["boxPlotData"] = filterBoxPlotData(chartData["boxPlotData"])
  //     }
  //     filteredData = getChartFilterData(driftOnMetricsChart, this.state.startDate, this.state.endDate, "", false, false, 10)
  //     driftOnMetricsKey = sectionName + driftOnMetricsChart["name"]
  //   }
  //   if (currentIndex === null) {
  //     let currentData = this.props.filteredData.filter(x => x.type === type && x.id === id)
  //     currentIndex = this.props.filteredData.indexOf(currentData[0])
  //   }

  //   filteredValues.push(prefix)
  //   if (this.state.isTreeSearch) {
  //     this.setState({ isTreeSearch: false, subString: "", filterSearch: "", newData: originalData, isDataChanged: !this.state.isDataChanged })
  //   }
  //   this.setState({
  //     envName: envName,
  //     currentIndex: currentIndex,
  //     envTableData: envTableData,
  //     filteredData: filteredData,
  //     selectedDataSource: datasourceId,
  //     datasetId: datasetId,
  //     recencyData: recencyData,
  //     envId: envId,
  //     duplicateRows: duplicateRows,
  //     attributeId: attributeId,
  //     datasetRow: datasetRow,
  //     selectedData: selectedData,
  //     lastRefresh: lastRefresh,
  //     showTreeView: false,
  //     metricsOptions: metricsOptions,
  //     sectionName: sectionName,
  //     datasetCount: datasetCount,
  //     attributeCount: attributeCount,
  //     datasourceCount: datasourceCount,
  //     isChartChanged: !this.state.isChartChanged,
  //     driftOnMetricsChart: driftOnMetricsChart,
  //     driftOnMetricsKey: driftOnMetricsKey,
  //     filteredValues: filteredValues,
  //     datasourceName: datasourceName,
  //     datasetName: datasetName,
  //     highlightedType: type,
  //     datasetIds: datasetIds,
  //     highlightedId: id,
  //     attributeName: attributeName
  //   })
  // }
  // processDatasourceChart(data, datasourceId) {
  //   let finalData = null;
  //   let filteredData = null;
  //   let attributeName = null;
  //   let datasetName = null;
  //   if (data !== undefined) {
  //     for (const [key, value] of Object.entries(data)) {
  //       for (const [attribute, chartDataValues] of Object.entries(value)) {
  //         const attributeKeysSplit = attribute.split(".");
  //         if (datasourceId !== null) {
  //           if (attributeKeysSplit[1] !== datasourceId) {
  //             continue;
  //           }
  //         }

  //         let metaData = this.props.metaData[attribute];
  //         if (metaData === undefined) {
  //           metaData = this.props.metaData;
  //           const filtered = Object.keys(metaData)
  //             .filter(key => key.startsWith(attribute))
  //             .reduce((obj, key) => {
  //               obj[key] = metaData[key];
  //               return obj;
  //             }, {});
  //           metaData = filtered[Object.keys(filtered)[0]];
  //           if (metaData !== undefined) {
  //             metaData = metaData.split(".").slice(0, metaData.split(".").length - 1).join(".");
  //           }
  //         }
  //         if (metaData !== undefined) {
  //           const metadataSplit = metaData.split(".");

  //           let toolTiptopHeader;
  //           let keysSplitLength = attributeKeysSplit.length;

  //           // Skip attribute level charts for consistency related metrics
  //           if (keysSplitLength === 4 && REQUIRES_CONTRIBUTION_INSTEAD_OF_CHART.includes(key)) {
  //             continue;
  //           }

  //           if (keysSplitLength === 4) {
  //             datasetName = metadataSplit[2];
  //             attributeName = metadataSplit[metadataSplit.length - 1];
  //             toolTiptopHeader = attributeName;
  //           } else {
  //             datasetName = metadataSplit[2];
  //             toolTiptopHeader = datasetName;
  //           }
  //           if (chartDataValues["name"] === "Data Drift") {
  //             let boxPlotData = {}
  //             let statistics = {}
  //             let quantile = chartDataValues["boxplot_data"]
  //             if (quantile !== undefined && quantile !== null) {
  //               statistics["attribute_name"] = attributeName
  //               statistics["quantile"] = quantile
  //               statistics["drift_patterns"] = chartDataValues["drift_patterns"]
  //               statistics["time"] = chartDataValues["time"]
  //               if (attributeName !== null) {
  //                 boxPlotData["chart_level"] = "Attribute"
  //               } else {
  //                 boxPlotData["chart_level"] = "Dataset"
  //               }
  //               boxPlotData["statistics"] = [statistics]
  //               chartDataValues["boxPlotData"] = boxPlotData
  //               chartDataValues["chartType"] = "boxPlotZoomable"
  //             }
  //           }
  //           if (attributeName !== null) {
  //             chartDataValues["attribute_name"] = attributeName;
  //           }
  //           chartDataValues["datasetName"] = datasetName;
  //           chartDataValues["toolTiptopHeader"] = toolTiptopHeader;
  //           chartDataValues["data_set_id"] = attributeKeysSplit[2];
  //           chartDataValues["errorChart"] = true;
  //           chartDataValues["title"] = `${metadataSplit.join(" > ")} - ${chartDataValues.name}`;
  //           chartDataValues["data_source_name"] = metadataSplit[1];
  //           chartDataValues[DQ_CHART_POINTS] = chartDataValues["value"];

  //           let chartTypeData = getChartTypeForMonitorCharts(chartDataValues);
  //           chartDataValues["type"] = chartTypeData.chartPatternType;
  //           let hasError = chartTypeData.hasError;
  //           chartDataValues["hasDrift"] = hasError;

  //           // We are changing scale of all charts to min max scale
  //           // Part of fix for issue 1038
  //           chartDataValues["scale"] = MIN_MAX_SCALE;



  //           normalizeChartData(chartDataValues, DQ_CHART_POINTS);
  //           let chartValues = chartDataValues[DQ_CHART_POINTS];
  //           let drift_len = chartValues.length;

  //           if (drift_len === 0) {
  //             continue;
  //           }

  //           if (drift_len > 1) {
  //             chartDataValues["error_percentage"] = chartValues[(drift_len - 1)].toFixed(2);
  //             chartDataValues["last_error"] = chartValues[(drift_len - 2)].toFixed(2);
  //           } else if (drift_len === 1) {
  //             chartDataValues["error_percentage"] = chartValues[(drift_len - 1)].toFixed(2);
  //             chartDataValues["last_error"] = chartValues[(drift_len - 1)].toFixed(2);
  //           } else {
  //             chartDataValues["error_percentage"] = 0;
  //             chartDataValues["last_error"] = 0;
  //           }


  //         }
  //         finalData = chartDataValues

  //         if (finalData !== null) {
  //           if (finalData["name"] === "Data Drift") {
  //             finalData["boxPlotData"] = filterBoxPlotData(finalData["boxPlotData"])
  //           }
  //           filteredData = getChartFilterData(finalData, this.state.startDate, this.state.endDate)
  //           this.setState({ chartDatasetName: datasetName, chartAttributeName: attributeName })
  //           break
  //         }
  //       }


  //       if (finalData !== null) {
  //         break
  //       }
  //     }
  //   }
  //   let result = { "finalData": finalData, "filteredData": filteredData }
  //   return result
  // }
  // closeIcon() {
  //   this.setState({ filterSearch: "", newData: {}, isDataChanged: !this.state.isDataChanged, isTreeSearch: false, subString: null });
  // }

  // handleChange = event => {
  //   let filterSearch = event.target.value
  //   this.setState({ filterSearch: filterSearch });

  //   const lowerCasedFilter = filterSearch.toLowerCase();
  //   if (lowerCasedFilter.length === 0 || !lowerCasedFilter.trim()) {
  //     this.setState({ newData: {}, isDataChanged: !this.state.isDataChanged, isTreeSearch: false, subString: null })
  //     return
  //   }
  //   let autoCompleteData = this.props.autoCompleteData
  //   let nestedData = _.cloneDeep(this.props.originalData)
  //   let newData = {}
  //   let searchTextFound = false
  //   for (let i = 0; i < autoCompleteData.length; i++) {
  //     let data = autoCompleteData[i]
  //     let type = data["type"]
  //     if (!data["name"].includes(lowerCasedFilter) || type === "Recent") {
  //       continue
  //     }
  //     searchTextFound = true

  //     let envId = data["envId"]
  //     let datasourceId = data["datasourceId"]
  //     let datasetId = data["datasetId"]
  //     let attributeId = data["attributeId"]
  //     if (!Object.keys(newData).includes(envId)) {
  //       newData[envId] = nestedData[envId]

  //       newData[envId]["isShow"] = true
  //       newData[envId]["isOpen"] = true
  //     }

  //     if (datasourceId !== undefined) {
  //       newData[envId]["childNodes"][datasourceId]["isOpen"] = true
  //       newData[envId]["childNodes"][datasourceId]["isShow"] = true
  //     }

  //     if (datasetId !== undefined) {
  //       newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["isOpen"] = true
  //       newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["isShow"] = true
  //     }

  //     if (attributeId !== undefined) {
  //       newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"][attributeId]["isOpen"] = true
  //       newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"][attributeId]["isShow"] = true
  //     }




  //   }

  //   this.setState({ newData: newData, isDataChanged: !this.state.isDataChanged, isTreeSearch: true, searchTextFound: searchTextFound, subString: filterSearch })
  // };
  // getId(highlightedType, filteredItem) {
  //   if (highlightedType === "Environment") {
  //     return filteredItem["envId"]
  //   } else if (highlightedType === "Datasource") {
  //     return filteredItem["datasourceId"]
  //   } else if (highlightedType === "Dataset") {
  //     return filteredItem["datasetId"]
  //   } else {
  //     return filteredItem["attributeId"]
  //   }
  // }
  // changeNavigation(position) {
  //   let currentIndex = this.state.currentIndex
  //   let filteredItem;
  //   let disableUp;
  //   let disableDown;
  //   let filteredData = this.props.filteredData
  //   if (currentIndex - 1 === 0) {
  //     disableUp = true
  //   } else {
  //     disableUp = false
  //   }
  //   if (currentIndex === (filteredData.length - 2)) {
  //     disableDown = true
  //   } else {
  //     disableDown = false
  //   }

  //   let highlightedType;
  //   let highlightedId;
  //   if (position === "down") {
  //     filteredItem = filteredData[currentIndex + 1]
  //     currentIndex = currentIndex + 1
  //     if (filteredItem !== undefined) {
  //       highlightedType = filteredItem["type"]
  //       highlightedId = this.getId(highlightedType, filteredItem)
  //     }
  //   } else {
  //     filteredItem = filteredData[currentIndex - 1]
  //     currentIndex = currentIndex - 1
  //     if (filteredItem !== undefined) {
  //       highlightedType = filteredItem["type"]
  //       highlightedId = this.getId(highlightedType, filteredItem)
  //     }
  //   }
  //   let envName = filteredItem["envName"];
  //   let datasourceName = filteredItem["datasourceName"]
  //   let datasetName = filteredItem["datasetName"]
  //   let attributeName = filteredItem["attributeName"]
  //   if (highlightedType === "Datasource") {
  //     datasourceName = filteredItem["name"]
  //   } else if (highlightedType === "Dataset") {
  //     datasetName = filteredItem["name"]
  //   } else if (highlightedType === "Attribute") {
  //     attributeName = filteredItem["name"]
  //   } else if (highlightedType === "Environment") {
  //     envName = filteredItem["name"]
  //   }
  //   this.changeData(envName, datasourceName, datasetName, attributeName,
  //     filteredItem["envId"], filteredItem["datasourceId"],
  //     filteredItem["datasetId"], filteredItem["attributeId"], highlightedId, highlightedType, currentIndex)
  //     this.setState({ disableUp: disableUp, disableDown: disableDown })
  // }

  // reset() {
  //   this.setState({ envName: "" });
  //   this.props.clearSearch();
  // }

  getIcon(type) {
    if (type === "Environment") {
      return faServer;
    } else if (type === "Datasource") {
      return faDatabase;
    } else if (type === "Dataset") {
      return faLayerGroup;
    } else {
      return faTag;
    }
  }


  // getFiltered(data, text, childNodes, original) {
  //   if (text === original) {
  //     data["isOpen"] = true
  //   }
  //   if (childNodes !== undefined) {
  //     let data1 = Object.values(childNodes)
  //     for (let i = 0; i < data1.length; i++) {
  //       this.getFiltered(data1[i], text, data1[i]["childNodes"], data1[i]["name"])
  //     }
  //   }
  //   else {
  //     return
  //   }

  // }

  // handleTreeViewButton() {
  //   this.setState({ showTreeView: !this.state.showTreeView })
  //   setTimeout(function () {
  //     if ($("#tree-view").hasClass("show")) {
  //       $('body').addClass("overflow-hidden");
  //     } else {
  //       $('body').removeClass("overflow-hidden");
  //     }
  //   }, 500);

  // }
  buildStructureForWatchlist(inputData,  searchText = "") {
    if (!inputData) return {};

    let { integrations, pipelines } = inputData;
    let result = {};
    let lowerSearchText = searchText.toLowerCase();
    let isSearchActive = !!searchText;
    let matchesSearch = (text) => text && text.toLowerCase().includes(lowerSearchText);

    if (integrations) {
        integrations.forEach((integration, index) => {
            let integrationId = integration.value;
            let integrationMatches = matchesSearch(integration.label);

            let integrationNode = {
                title: integration.label,
                type: "Datasource",
                id: integrationId,
                childNodes: [],
                isFirstDatasource: index === 0,
            };

            // Find pipelines related to this integration
            let relatedPipelines = pipelines.filter(pipeline => pipeline.p_integration_id === integrationId);

            relatedPipelines.forEach((pipeline, index) => {
                let pipelineId = pipeline.value; // Corrected from `pipeline_id` to `value`
                let pipelineMatches = matchesSearch(pipeline.label);
                let pipelineNode = {
                    title: pipeline.label,
                    type: "Pipeline",
                    id: pipelineId,
                    integrationId: integrationId,
                    firstPipeline: isSearchActive ? true : index === 0,
                    is_disabled: pipeline.no_runs_found === true,
                };

                if (pipelineMatches) {
                    integrationNode.childNodes.push(pipelineNode);
                    integrationMatches = true;
                }
            });

            if (integrationMatches || integrationNode.childNodes.length > 0) {
                result[integrationId] = integrationNode;
            }
        });
    }

    return result;
}




//function for nested data 
// buildNestedStructure(inputData, label, id, searchText, watchlistOpen, envId) {
//   if (!inputData) return {};

//   let { integrations, datasets, attributes } = inputData;
//   let result = {};
//   let lowerSearchText = searchText ? searchText.toLowerCase() : "";
//   let isSearchActive = !!searchText;

//   let matchesSearch = (text) => text && text.toLowerCase().includes(lowerSearchText);

//   if (integrations) {
    
//     integrations
//     .filter((integration) => integration.env_id === envId)
//     .forEach((integration) => {
//       let datasourceId = integration.value;
//       let datasourceMatches = matchesSearch(integration.label);
//       let datasourceNode = {
//         title: integration.label,
//         type: "Datasource",
//         id: datasourceId,
//         childNodes: [],
//         envId : envId 
//       };

//       if (datasets && datasets[datasourceId]) {
//          datasets[datasourceId].forEach((dataset, index) => {     
          
//         let isFirstDataset = true; // Flag to track the first dataset

//           let datasetId = dataset.value;
//           let datasetMatches = matchesSearch(dataset.label);
//           let datasetNode = {
//             title: normalizeChildDatasetName(dataset.label),
//             type: "Dataset",
//             error: dataset.error,
//             id: datasetId,
//             childNodes: [],
//             firstDataset: isSearchActive ? true : index === 0, // Set true if search is active
//           };

//           // Once the first dataset is processed, set isFirstDataset to false
//           if (isFirstDataset) {
//           isFirstDataset = false;
//           }

//           let hasMetrics = false;

//           if (!watchlistOpen) {
//             let metrics = dataset.metrics?.filter((metric) => matchesSearch(metric.metrics_name)) || [];
//             let customMetrics = dataset.custom_metrics?.filter((metric) => matchesSearch(metric.metrics_name)) || [];

//             if (metrics.length > 0) {
//               datasetNode.childNodes.push({
//                 title: "Metrics",
//                 type: "Metrics",
//                 childNodes: metrics.map((metric) => ({
//                   title: metric.metrics_name,
//                   latest: metric.latest,
//                   previous: metric.previous,
//                   error: metric.error,
//                   id: metric.metrics_id,
//                   is_disabled: metric.is_disabled
//                 })),
//               });
//               hasMetrics = true;
//             }

//             if (customMetrics.length > 0) {
//               datasetNode.childNodes.push({
//                 title: "Custom Metrics",
//                 type: "CustomMetrics",
//                 childNodes: customMetrics.map((metric) => ({
//                   title: metric.metrics_name,
//                   latest: metric.latest,
//                   previous: metric.previous,
//                   error: metric.error,
//                   id: metric.metrics_id,
//                   is_disabled: metric.is_disabled
//                 })),
//               });
//               hasMetrics = true;
//             }
//           }

//           if (attributes && attributes[datasetId]) {
//             attributes[datasetId].forEach((attribute) => {
//               let attributeId = attribute.value;
//               let attributeMatches = matchesSearch(attribute.label);
//               let attributeNode = {
//                 title: attribute.label,
//                 error: attribute.error,
//                 type: "Attribute",
//                 id: attributeId,
//                 childNodes: [],
//               };

//               let hasAttributeMetrics = false;
//               if (!watchlistOpen) {
//                 let attributeMetrics = attribute.metrics?.filter((metric) => matchesSearch(metric.metrics_name)) || [];
//                 let attributeCustomMetrics = attribute.custom_metrics?.filter((metric) => matchesSearch(metric.metrics_name)) || [];

//                 if (attributeMetrics.length > 0) {
//                   attributeNode.childNodes.push({
//                     title: "Metrics",
//                     type: "Metrics",
//                     childNodes: attributeMetrics.map((metric) => ({
//                       title: metric.metrics_name,
//                       latest: metric.latest,
//                       previous: metric.previous,
//                       error: metric.error,
//                       id: metric.metrics_id,
//                       is_disabled: metric.is_disabled
//                     })),
//                   });
//                   hasAttributeMetrics = true;
//                 }

//                 if (attributeCustomMetrics.length > 0) {
//                   attributeNode.childNodes.push({
//                     title: "Custom Metrics",
//                     type: "CustomMetrics",
//                     childNodes: attributeCustomMetrics.map((metric) => ({
//                       title: metric.metrics_name,
//                       latest: metric.latest,
//                       previous: metric.previous,
//                       error: metric.error,
//                       id: metric.metrics_id,
//                       is_disabled: metric.is_disabled
//                     })),
//                   });
//                   hasAttributeMetrics = true;
//                 }
//               }

//               if (attributeMatches || hasAttributeMetrics) {
//                 datasetNode.childNodes.push(attributeNode);
//                 datasetMatches = true;
//               }
//             });
//           }

//           if (datasetMatches || hasMetrics) {
//             datasourceNode.childNodes.push(datasetNode);
//             datasourceMatches = true;
//           }
//         });
//       }

//       if (datasourceMatches) {
//         result[datasourceId] = datasourceNode;
//       }
//     });
//   }

//   return result;
// }




//search in left panel 
handleLeftSearchPanel = (event) => {
  this.setState({ leftSearchText: event.target.value });
};


  render() { 
    
    
    let data = []
    if (Object.values(this.state.newData).length > 0) {
      // data = Object.values(this.state.newData)
    } else {
      // data = this.state.data !== undefined && this.state.data !== null ? this.props.integrations_data  : [];
    }
    // let env_name = this.props.selectedEnv; 
    // let env_label = env_name && env_name.label ? env_name.label : this.props.latest_env_name;
    // let env_id = env_name && env_name.value ? env_name.value : this.props.latest_env_name;    
    // let treedata = null;
    if(this.props.watchListOpen === true){
      data=this.buildStructureForWatchlist(this.props.metaDataResponse,this.props.saveWatchListSearchText) 
      }
      
    // else if (this.props.metricsValueResponse && this.props.watchListOpen !== true ) {
    //   treedata = this.buildNestedStructure(this.props.metricsValueResponse,env_label,env_id,this.state.leftSearchText,this.props.watchListOpen);
    //    data = this.props.saveWatchListSearchText !== undefined && this.props.saveWatchListSearchText !== "" ? Object.values(this.buildNestedStructure(this.props.metricsValueResponse, env_label, env_id, this.props.saveWatchListSearchText, this.props.watchListOpen,this.props.selectedEnvId)): Object.values(treedata);
    // }
// Ensure `AllInterationsResponse` integrations are added into the data
// if ( this.props.AllInterationsResponse && this.props.watchListOpen !== true) {
//   let isFirstDatasource = true;

//   // Apply search filter to integrations
//   let filteredIntegrations = this.props.AllInterationsResponse.filter(integration => 
//       integration.label.toLowerCase().includes(this.state.leftSearchText.toLowerCase())
//   );

//   if (this.props.selectedWatchlistId) {
//       filteredIntegrations = filteredIntegrations.filter(integration => 
//           integration.value === this.props.selectedWatchlistId
//       );
//   }

//   let allIntegrations = filteredIntegrations.map((integration, index) => {
//       let integrationNode = {
//           title: integration.label,
//           type: "Datasource",
//           id: integration.value,
//           envId:  this.props.selectedEnvId,
//           childNodes: [],
//           isFirstDatasource: isFirstDatasource,
//           expanded: this.state.leftSearchText.length > 0 
//       };

//       // Set the flag to false after processing the first integration
//       isFirstDatasource = false;

//       return integrationNode;
//   });

//   // Add the integrations to the existing `data`
//   allIntegrations.forEach(integration => {
//       let existingIntegration = data.find(item => item.id === integration.id);
//       if (existingIntegration) {
//           existingIntegration.envId = this.props.selectedEnvId;
//           existingIntegration.childNodes.push(...integration.childNodes);
//       } else {
//           data.push(integration);
//       }
//   });
// }

    let profileData = this.state.profileData;
    let keys = ["avg", "min", "max", "std"]
    if (profileData !== undefined && profileData !== null) {
      for (let i = 0; i < keys.length; i++) {
        if (typeof (profileData[keys[i]]["drift"]) === "number") {
          profileData[keys[i]]["drift"] = parseFloat(profileData[keys[i]]["drift"].toFixed(4))
        }
        if (typeof (profileData[keys[i]]["value"]) === "number") {
          profileData[keys[i]]["value"] = parseFloat(profileData[keys[i]]["value"].toFixed(4))
        }
      }
    }

    for (let [key] of Object.entries(activeItem)) {
      activeItem[key] = "breadcrumb-item";
    }
    activeItem[this.state.highlightedType] = 'breadcrumb-item active'
    // let sizeData = 0
    // let filtered = this.props.dataModule.dataSize.filter(x => (this.state.datasetIds.includes(x.data_set_id.toString())))
    // for (let i = 0; i < filtered.length; i++) {
    //   sizeData = sizeData + filtered[i]["size"]

    // }
    // let showTreeView = this.state.showTreeView
    // sizeData = getConvertedSize(sizeData)
    // if (data.length > 0) {
    //   let filteredData = data.filter(item => item.envId !== undefined && item.envId === this.props.selectedEnvId);
    //   data = filteredData.length > 0 ? filteredData : data;
    // }
    return (<><div className="qd_tree-wrapper" id="tree-view">
      <div className="qd_tree-view-container">
        {this.state.showSearchFilter ?
          <div className="qd_tree-view-top">
            <div className="title">
              <div className="title-left">
                <label>Main Source</label>
              </div>
              <div className="title-right">
                <ul>
                  <li>New</li>
                  <li>Old</li>
                </ul>
              </div>
            </div>
            <div className="qd-search-bar has-btn-close qd-search-bar--bg-gray">
              <div className="input-group">
                <div className="input-group-prepend">
                  <button id="button-addon4" type="button" className="btn">
                    <svg className='d-block' width="16" height="16" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.889 12.5237L10.35 9.98474C10.1222 9.75694 9.75283 9.75694 9.52502 9.98474C9.29722 10.2126 9.29722 10.5819 9.52502 10.8097L12.064 13.3487C12.2918 13.5765 12.6612 13.5765 12.889 13.3487C13.1168 13.1209 13.1168 12.7515 12.889 12.5237Z" fill="#99A1B7"/>
                      <path d="M6.41667 11.8333C3.82408 11.8333 1.75 9.75923 1.75 7.16667C1.75 4.57408 3.82408 2.5 6.41667 2.5C9.00923 2.5 11.0833 4.57408 11.0833 7.16667C11.0833 9.75923 9.00923 11.8333 6.41667 11.8333ZM6.41667 3.66667C4.39444 3.66667 2.91667 5.14444 2.91667 7.16667C2.91667 9.18891 4.39444 10.6667 6.41667 10.6667C8.43891 10.6667 9.91667 9.18891 9.91667 7.16667C9.91667 5.14444 8.43891 3.66667 6.41667 3.66667Z" fill="#99A1B7"/>
                    </svg>
                  </button>
                </div>
                <input type="search" placeholder="Search..." className="form-control"  onChange={this.handleLeftSearchPanel} value={this.state.leftSearchText}/>
              </div>
              {this.state.leftSearchText && <button className="btn btn-clear" title="clear"onClick={() => this.setState({ leftSearchText: '' })}><i className="icon-close"></i></button>}
            </div>
          </div> 
        : ''}
         {/* <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
        <TreeView data={initialTreeData} defaultExpandedId={6} />
      </div> */}
        {/* { this.props.leftPanelLoader===true ? <Load/> :
        this.state.isRedirect && !(this.state.isTreeSearch) ?
          <div className="search-controls-section">
            <div className="qd_tree-search-controls">
              <p><strong>  {this.props.searchCount}</strong> results</p>
              <div className="search-actions">
                {this.props.filteredData ? <><button disabled={this.state.disableUp || this.props.filteredData.length <= 1} className="btn" id="up" onClick={this.changeNavigation.bind(this, "up")} title="Previous Match (&#8593; Up Arrow)">
                  <i className="icon_arrow-up"></i></button>
                  <span className="icon-divider"></span>
                  <button disabled={this.state.disableDown || this.props.filteredData.length <= 1} className="btn" id="down" onClick={this.changeNavigation.bind(this, "down")} title="Next Match (&#8595; Down Arrow)"><i className="icon_arrow-down"></i></button>
                </>
                  :
                  ""
                }
                <button className="btn" title="Close (Escape)" onClick={this.reset}><i className="icon_cross"></i></button>
              </div>
            </div>
          </div>
          :
          ""
        } */}
        <Scrollbars className="custom-scrollbar"
          autoHeightMin={0}
          autoHeightMax="calc(100% - 70px)"
          thumbMinSize={30}
          universal={true}
        >
          <div style={{ paddingBottom: '70px' }}>
            <ul className="qd_tree-view vertical-lined-tree-view" key={this.state.isDataChanged}>
              {(data.length === 0 || (typeof data === "object" && Object.keys(data).length === 0)) ?
                  <div className="alert_notree-search-match">
                  <Image
                    src="icon_exclamation_gray"
                  />
                {((Array.isArray(data) && data.length === 0) || data === "") ? (this.props.saveWatchListSearchText || this.state.leftSearchText) ? <p>No matches found for your search</p> : <p>No data found</p>
                   : (typeof data === "object" && Object.keys(data).length === 0) ? <p>No data found</p> : null}
                  </div>
                :
                Object.values(data).map(({ id, title, childNodes, type,isFirstDatasource }, index) => (
                  <>
                    <Node
                      key={title}
                      isRedirect={this.state.isRedirect || this.state.isTreeSearch}
                      envName={title}
                      isTreeSearch={this.state.isTreeSearch}
                      subString={this.props.saveWatchListSearchText}
                      title={title}
                      type={type}
                      isSearchHappened={!this.props.isSearchHappened && !this.state.isTreeSearch}
                      id={id}
                      childNodes={Object.values(childNodes)}
                      // isOpen={false}
                      // isShow={false}
                      highlightedId={this.state.highlightedId}
                      highlightedType={this.state.highlightedType}
                      changeData={this.changeData}
                      showCustomCheckbox={this.state.showCustomCheckbox}
                      isNodeHasActions={this.state.isNodeHasActions}
                      // isChecked={this.props.isChecked}
                      // handleCheckboxChange={this.state.handleCheckboxChange}
                      // arrowIndicator={this.props.arrowIndicator}
                      // newValue={this.props.newValue}
                      // oldValue={this.props.oldValue}
                      handleSaveWatchlistCheckboxChange ={this.props.handleSaveWatchlistCheckboxChange}
                      checkedStates={this.props.checkedStates}
                      watchListOpen={this.props.watchListOpen}
                      AllInterationsResponse = {this.props.AllInterationsResponse}
                      getMetricsValueResponse = {this.props.getMetricsValueResponse}
                      selectedEnvId = {this.props.selectedEnvId}
                      isFirstDatasource={index === 0 && type === "Datasource"}
                      selectedWatchlistId = {this.props.selectedWatchlistId}
                      inProgress = {this.props.inProgress}
                      pipelinesource_data={this.props.pipelinesource_data}
                      pipelinesource_data_leftpanel = {this.props.pipelinesource_data_leftpanel}
                    />
                  </>
                ))
              }              

            </ul>
          </div>
        </Scrollbars>
      </div>
    </div>
      <div className="qd_tree-overlay"></div>
    </>);

  }
}

export default PipelineLeftPanel;


class Node extends React.Component {
  constructor(props) {
    super(props);
    let datasourceName = "";
    let datasourceId = null;
    let datasetName = "";
    // let datasetId = null;
    let attributeName = "";
    // let attributeId = null;
    let envId = null;
    let envName = "";

    if (props.type === "Datasource") {
      datasourceName = props.title;
      datasourceId = props.id;
    } 
    // else if (props.type === "Dataset") {
    //   datasetName = props.title;
    //   datasetId = props.id;
    // } else if (props.type === "Attribute") {
    //   attributeName = props.title;
    //   attributeId = props.id;
    // } 
    let highlightedClass = ""
    let listClassName = ""
    if (this.props.highlightedId === this.props.id && this.props.highlightedType === this.props.type && this.props.childNodes.length !== 0) {
      highlightedClass = "search-highlight-selected"
      listClassName = "active"
    }

    this.state = {
      isOpen:false,
      isShow: this.props.isShow,
      envName: envName === "" ? this.props.envName : envName,
      datasourceName: datasourceName === "" ? this.props.datasourceName : datasourceName,
      datasetName: datasetName === "" ? this.props.datasetName : datasetName,
      attributeName: attributeName,
      envId: envId === null ? this.props.envId : envId,
      highlightedId: this.props.highlightedId,
      highlightedType: this.props.highlightedType,
      datasourceId: datasourceId === null ? this.props.datasourceId : datasourceId,
      // datasetId: datasetId === null ? this.props.datasetId : datasetId,
      // attributeId: attributeId === null ? this.props.attributeId : attributeId,
      isChanged: false,
      listClassName: listClassName,
      highlightedClass: highlightedClass,
      showCustomCheckbox : this.props.showCustomCheckbox,
      isNodeHasActions : this.props.isNodeHasActions,
      isChecked:this.props.isChecked,
      arrowIndicator:this.props.arrowIndicator,
      newValue :this.props.newValue,
      oldValue :this.props.oldValue,
      checkedStates:this.props.checkedStates,
      isMetricsOpen:false,
      selectedEnvId : this.props.selectedEnvId,
      noRunsToast: false,
    };
    this.getIcon = this.getIcon.bind(this);
    this.getApi = getApi.bind(this);
    this.toggle = this.toggle.bind(this);
    this.setupClickEvents = this.setupClickEvents.bind(this);
  }


  componentDidUpdate(prevProps) {
    if (prevProps.highlightedId !== this.props.highlightedId) {
      this.setState({ highlightedType: this.props.highlightedType, highlightedId: this.props.highlightedId });
      if (this.props.highlightedId === this.props.id && this.props.highlightedType === this.props.type) {
        this.setState({ highlightedClass: "search-highlight-selected", listClassName: "active" });
      } else {
        this.setState({ highlightedClass: "", listClassName: "" });
      }

    }
  }
      
  toggle = async (clickedId) => {
    if(this.props.type === "Dataset"){
      this.setupClickEvents(this.props.type, String(this.props.datasetId), clickedId);
    }
    else if(this.props.type==="Attribute"){
      this.setupClickEvents(this.props.type, String(this.props.attributeId), clickedId);
    }
    else if(this.props.type === "Metrics" || this.props.type === "CustomMetrics"){
      let id= this.state.datasetId
      if(this.state.attributeId!== undefined){
        id= id+this.state.attributeId
      }
      this.setupClickEvents(this.props.type, String(id), clickedId);
    }

    // Set the state to toggle 'isOpen'
    this.setState({
        isOpen: !this.state.isOpen,
        isActive: false
    });


    let isChanged = this.state.isChanged;
    if (!isChanged) {
        this.setState({ isChanged: true });
    }
    
    this.props.type === "Datasource"  && this.props.watchListOpen !== true && await this.props.getMetricsValueResponse(this.props.id,this.props.selectedWatchlistId);
    this.props.watchListOpen !== true && this.props.changeData(this.state.envName, this.state.datasourceName,
      this.state.datasetName, this.state.attributeName,
      this.state.envId, this.state.datasourceId,
      this.state.datasetId, this.state.attributeId, this.props.id, this.props.type,this.state.isOpen, null,this.props.title)
  };
        
  toggleForWatchlistOpen = async () => {
    this.setState({
        isOpen: !this.state.isOpen,
        isActive: false
    });


    let isChanged = this.state.isChanged;
    if (!isChanged) {
        this.setState({ isChanged: true });
    }
  }
  getIcon(type) {     
    if (type === "Environment") {
      return faServer;
    } else if (type === "Datasource") {
      return faDatabase;
    } else if (type === "Dataset") {
      return faLayerGroup;
    } else {
      return faTag;
    }
  }
  getUlClassName(type,childNodes) {
    let className = ""
    if (!Array.isArray(childNodes)) {
      childNodes = [];
    }    
    if (type === "Environment") {
      className = this.state.isOpen || (this.props.isSearchHappened && !(this.state.isChanged)) ? "nested tree_top-level active" : "nested"
    } else if (type === "Datasource") {
      className = this.state.isOpen || (this.props.isSearchHappened && !(this.state.isChanged)) ? "nested active" : "nested has-no-caret"
    } else if (type === "Dataset" && childNodes.length > 0 && this.props.watchListOpen !== true) {
      className = this.state.isOpen || (this.props.isSearchHappened && !(this.state.isChanged)) ? "nested active" : "nested has-no-caret"
    } else if (type === "Attribute" && childNodes.length > 0 && this.props.watchListOpen !== true){
      className = this.state.isOpen || (this.props.isSearchHappened && !(this.state.isChanged)) ? "nested active" : "nested has-no-caret"
    }
    else {
      className = this.state.isOpen || (this.props.isSearchHappened && !(this.state.isChanged)) ? "nested has-no-caret active" : "nested has-no-caret"
    }
    return className;
  }
getHighlightedText(text, searchText) {
  if (!searchText) return text;
  const parts = text.split(new RegExp(`(${searchText})`, 'gi'));
  return parts.map((part, index) =>
    part.toLowerCase() === searchText.toLowerCase() ? (
      <span  className='search-text-highlight'>{part}</span>
    ) : (
      part
    )
  );
}
  componentWillUnmount() {
    $(`div[id^='${this.props.type}-left-panel-div-']`).off('click'); // Remove event listeners
  }

  setupClickEvents(type, excludeId = null, clickedId=null) {
    if(type==="Metrics" || type === "CustomMetrics"){
      let existingId = type+"-left-panel-div-"+this.state.datasetId+type
      if(type === "CustomMetrics"){
          existingId = type+"-left-panel-div-"+type
      }
      if (clickedId===existingId && (this.state.attributeId === undefined || this.state.attributeId === null)) {
        this.props.changeData(
          this.state.envName, this.state.datasourceName,
          this.state.datasetName, null,
          this.state.envId, this.state.datasourceId,
          this.state.datasetId, null,
          this.props.id, "Dataset", false, this.props.title
        );

        $(`div[id^='Attribute-left-panel-div-']`).each(function() {
          let id = $(this).attr('id');
             if ($("#" + id).is(" .caret.caret-down")) {
              $("#" + id).trigger("click");
            } else {
            }
        });

      }
       else {
        this.props.changeData(
          this.state.envName, this.state.datasourceName,
          this.state.datasetName, this.state.attributeName,
          this.state.envId, this.state.datasourceId,
          this.state.datasetId, this.state.attributeId,
          this.props.id, "Attribute", false, this.props.title
        );

      }

    }
    else{

      if(this.props.type==="Attribute"){

        $(`div[id^='Metrics-left-panel-div-${this.state.datasetId}Metrics']`).each(function() {
          let id = $(this).attr('id');
          if ($("#" + id).is(" .caret.caret-down")) {
              $("#" + id).trigger("click");
            }
        });
      
        // CustomMetrics-left-panel-div-CustomMetrics
        $(`div[id^='CustomMetrics-left-panel-div-CustomMetrics']`).each(function() {
          let id = $(this).attr('id');
          if ($("#" + id).is(" .caret.caret-down")) {
              $("#" + id).trigger("click");
            }
        });
      
      }
      
      

      $(`div[id^='${type}-left-panel-div-']`).each(function() {
        let id = $(this).attr('id');
        if (id !== type+"-left-panel-div-" + excludeId+type) {
           if ($("#" + id).is(" .caret.caret-down")) {
            $("#" + id).trigger("click");
          } 
        } 
      });
    }

    
  }

//  componentDidMount() {
//     if (this.props.firstDataset && !this.props.watchListOpen) {
//       $(`#${this.state.datasetId}`).addClass("open");
//       this.setState({ isActive: true, isOpen: true }, async () => {
//         await this.props.changeData(
//           this.state.envName, this.state.datasourceName,
//           this.state.datasetName, this.state.attributeName,
//           this.state.envId, this.state.datasourceId,
//           this.state.datasetId, this.state.attributeId,
//           this.props.id, this.props.type, false, this.props.title
//         );
//       });
//     }
//     else if (this.props.watchListOpen && this.props.firstDataset){
//       $(`#${this.state.datasetId}`).addClass("open");
//     }
//     if (this.props.type === "Datasource" && this.props.isFirstDatasource && !this.state.isOpen && !this.props.watchListOpen) {
//       this.fetchMetricsValueData();
//   }
//   }
  
//   fetchMetricsValueData = async () => {
//       await this.props.getMetricsValueResponse(this.props.id, this.props.selectedWatchlistId);
//   };
  
//    getSelectedCounts = (checkedStates, childNodes) => {
//     let counts = { Dataset: 0, Attribute: 0, Partition: 0, PartitionAttribute: 0 };

//     let countCheckedNodes = (nodes) => {
//         nodes.forEach(node => {
//             if (checkedStates[node.id]?.checked) {
//                 if (node.type === "Dataset") {
//                     counts.Dataset += 1;
//                 } else if (node.type === "Attribute") {
//                     counts.Attribute += 1;
//                 } else if (node.type === "Partition") {
//                     counts.Partition += 1;
//                 } else if (node.type === "Partition Attribute") {                  
//                     counts.PartitionAttribute += 1;
//                 }
//             }
//             if (node.childNodes && node.childNodes.length > 0) {
//                 countCheckedNodes(node.childNodes);
//             }
//         });
//     };

//     countCheckedNodes(childNodes);
//     return counts;
// };

  render() {
    const { title, childNodes, type } = this.props;
   
    let ulClassName;
    if (childNodes && childNodes.length > 0) {
      ulClassName = this.getUlClassName(type, childNodes);
    } else {
      ulClassName = this.getUlClassName(type);
    }
        let childrenLength = childNodes.filter(x => x.isShow === true)
    let uniqueId = "";
    if (this.props.type === "Datasource") {
      
      uniqueId =  `Datasource-${this.state.datasourceId}`; // Unique ID for Datasource
    } else if (this.props.type === "Pipeline") {
      uniqueId = `Pipeline-${this.props.id}`; // Unique ID for Dataset
    }



    // let selectedCounts = this.getSelectedCounts(this.props.checkedStates, this.props.childNodes);

    // Now render the component
    return (
        <li className={`${this.state.isActive ? "active" : this.state.listClassName}`}> 
        {
        <>
        <div 
            className={childNodes.length === 0 && type !== "Datasource" ? (this.props.watchListOpen !== true ? "d-flex align-items-end w-100":"") : (this.state.isOpen || (this.props.isSearchHappened && ["Environment", "Datasource"].includes(type) && !(this.state.isChanged) && childNodes.length !== 0) ? "caret caret-down" : "caret")} 
            id={type+"-left-panel-div-"+uniqueId+type}
            style={{ cursor: 'pointer' }}
            onClick={(event) => {
              if (this.props.is_disabled === true) {
                this.setState({ noRunsToast: true });
                setTimeout(() => this.setState({ noRunsToast: false }), 3000);
                return;
              }
              const clickedId = event.currentTarget.id;
              if (this.props.watchListOpen !== true) {
                this.toggle(clickedId);
              } else {
                this.toggleForWatchlistOpen(clickedId);
              }
            }}
          >
            
        <div className="qd_tree-label">
            {/* {this.state.showCustomCheckbox ? */}
           <input
           type="checkbox"
           id={uniqueId}
           onClick={(event) => this.props.handleSaveWatchlistCheckboxChange(event, type, uniqueId,this.props.childNodes)}
           checked={this.props.checkedStates[uniqueId]?.checked}  // Use checkedStates to manage checkbox state
           label=""
          //  custom
           className="mr-2"         />
          {/* : ''   */}
            {/* } */}
            <i>
            { type ==="Pipeline" ? <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.60478 5.61891H6.65343V6.66062H3.97499C3.64348 6.66062 3.37318 6.9262 3.37318 7.25191V8.38001H2.35643C2.02146 8.38001 1.75 8.64784 1.75 8.97584V11.6542C1.75 11.9833 2.0226 12.25 2.35643 12.25H5.08138C5.41638 12.25 5.68772 11.9822 5.68887 11.6542V8.97584C5.68887 8.64672 5.41627 8.38001 5.08244 8.38001H4.06623V7.34156H9.93414V8.38H8.91752C8.58255 8.38 8.31109 8.64784 8.31109 8.97583V11.6542C8.31109 11.9833 8.58369 12.25 8.91752 12.25H11.6435C11.9785 12.25 12.25 11.9822 12.25 11.6542V8.97583C12.25 8.64672 11.9774 8.38 11.6435 8.38H10.6285V7.25191C10.6285 6.9262 10.3582 6.66062 10.0266 6.66062H7.34649V5.61891H8.39542C8.71191 5.61891 8.96962 5.36581 8.96846 5.05486V2.31406C8.96846 2.00308 8.71086 1.75 8.39437 1.75H5.60478C5.28827 1.75 5.03069 2.0031 5.03069 2.31406V5.05486C5.03069 5.36583 5.28829 5.61891 5.60478 5.61891Z" fill="currentColor" />
              </svg> :  (() => {
                  const pipeline = this.props.pipelinesource_data_leftpanel.find(
                    (item) => item.p_integration_name === title
                  );
                  let iconType = "default"; 
                  if (pipeline) {
                    if (pipeline.integration_type === "airflow") iconType = "airflow";
                    else if (pipeline.integration_type === "glue") iconType = "glue";
                    else if (pipeline.integration_type === "synapse") iconType = "azure";
                    else if (pipeline.integration_type === "adf") iconType = "data_factory";
                    else if (pipeline.integration_type === "composer") iconType = "composer";
                    else if (pipeline.integration_type === "mwa_airflow") iconType = "amazon_mwaa";
                    else if (pipeline.integration_type === "dbt" || pipeline.integration_type === "dbt_core") iconType = "dbt";
                    else if (pipeline.integration_type === "" || !pipeline.integration_type) iconType = "default"; 
                  }

                  return <Image src={`connector_icon_${iconType}`} alt={iconType} />;
                })()}
               
              {/* {this.props.error && <sup>
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 7.26392C5.14167 7.26392 5.26042 7.21751 5.35625 7.1247C5.45208 7.03188 5.5 6.91687 5.5 6.77966C5.5 6.64245 5.45208 6.52744 5.35625 6.43462C5.26042 6.34181 5.14167 6.2954 5 6.2954C4.85833 6.2954 4.73958 6.34181 4.64375 6.43462C4.54792 6.52744 4.5 6.64245 4.5 6.77966C4.5 6.91687 4.54792 7.03188 4.64375 7.1247C4.73958 7.21751 4.85833 7.26392 5 7.26392ZM5 5.32688C5.14167 5.32688 5.26042 5.28047 5.35625 5.18765C5.45208 5.09483 5.5 4.97982 5.5 4.84262V2.90557C5.5 2.76836 5.45208 2.65335 5.35625 2.56053C5.26042 2.46772 5.14167 2.42131 5 2.42131C4.85833 2.42131 4.73958 2.46772 4.64375 2.56053C4.54792 2.65335 4.5 2.76836 4.5 2.90557V4.84262C4.5 4.97982 4.54792 5.09483 4.64375 5.18765C4.73958 5.28047 4.85833 5.32688 5 5.32688ZM5 9.68523C4.30833 9.68523 3.65833 9.55811 3.05 9.30387C2.44167 9.04964 1.9125 8.7046 1.4625 8.26877C1.0125 7.83293 0.65625 7.32042 0.39375 6.73124C0.13125 6.14205 0 5.51251 0 4.84262C0 4.17272 0.13125 3.54318 0.39375 2.95399C0.65625 2.36481 1.0125 1.8523 1.4625 1.41646C1.9125 0.98063 2.44167 0.635593 3.05 0.381356C3.65833 0.127119 4.30833 0 5 0C5.69167 0 6.34167 0.127119 6.95 0.381356C7.55833 0.635593 8.0875 0.98063 8.5375 1.41646C8.9875 1.8523 9.34375 2.36481 9.60625 2.95399C9.86875 3.54318 10 4.17272 10 4.84262C10 5.51251 9.86875 6.14205 9.60625 6.73124C9.34375 7.32042 8.9875 7.83293 8.5375 8.26877C8.0875 8.7046 7.55833 9.04964 6.95 9.30387C6.34167 9.55811 5.69167 9.68523 5 9.68523Z" fill="#F64E60"/>
                </svg>
              </sup>} */}
            </i>
            {this.props.subString ? this.getHighlightedText(title, this.props.subString) : (title)}
           
          </div>
          
          {/* { this.state.isNodeHasActions   && childNodes.length === 0  && type !== "Dataset" && type !== "Datasource"? 
          <div className="qd_tree-actions">
            <span className="performance-stats">
              {this.state.arrowIndicator === true && latest !== previous && <span className="svg-icon">
                {previous === "NA" || latest > previous ? (
                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                 <path d="M11.9306 6.75C12.0187 6.75 12.1037 6.76558 12.1856 6.79675C12.2676 6.82792 12.3416 6.87655 12.4077 6.94265L15.3074 9.84231C15.4358 9.97074 15.5 10.1298 15.5 10.3194C15.5 10.5091 15.4358 10.6681 15.3074 10.7966C15.1752 10.9336 15.0152 11.0012 14.8274 10.9993C14.6396 10.9974 14.4815 10.9298 14.3531 10.7966L12.6132 9.06226V16.5673C12.6132 16.757 12.5468 16.9182 12.4141 17.0509C12.2814 17.1836 12.1202 17.25 11.9306 17.25C11.7409 17.25 11.5797 17.1836 11.447 17.0509C11.3143 16.9182 11.2479 16.757 11.2479 16.5673V9.06226L9.51361 10.7966C9.37659 10.9336 9.2154 11.0021 9.03004 11.0021C8.84468 11.0021 8.68349 10.9336 8.54648 10.7966C8.41319 10.6595 8.34777 10.4984 8.3502 10.313C8.35263 10.1276 8.41805 9.97074 8.54648 9.84231L11.4462 6.94265C11.5122 6.87656 11.5875 6.82793 11.6718 6.79675C11.7562 6.76558 11.8425 6.75 11.9306 6.75Z" fill="#198754"/>
                 </svg>
                 ) : 
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.0694 17.25C11.9813 17.25 11.8963 17.2344 11.8144 17.2032C11.7324 17.1721 11.6584 17.1234 11.5923 17.0574L8.69265 14.1577C8.56422 14.0293 8.5 13.8702 8.5 13.6806C8.5 13.4909 8.56422 13.3319 8.69265 13.2034C8.8248 13.0664 8.98478 12.9988 9.17257 13.0007C9.36036 13.0026 9.51846 13.0702 9.64688 13.2034L11.3868 14.9377L11.3868 7.43265C11.3868 7.243 11.4532 7.08181 11.5859 6.94909C11.7186 6.81636 11.8798 6.75 12.0694 6.75C12.2591 6.75 12.4203 6.81636 12.553 6.94909C12.6857 7.08181 12.7521 7.243 12.7521 7.43265L12.7521 14.9377L14.4864 13.2034C14.6234 13.0664 14.7846 12.9979 14.97 12.9979C15.1553 12.9979 15.3165 13.0664 15.4535 13.2034C15.5868 13.3405 15.6522 13.5016 15.6498 13.687C15.6474 13.8724 15.5819 14.0293 15.4535 14.1577L12.5538 17.0574C12.4878 17.1234 12.4125 17.1721 12.3282 17.2032C12.2438 17.2344 12.1575 17.25 12.0694 17.25Z" fill="#F64E60"/>
                </svg>}
              </span>
              }
              {this.state.newValue === true && <span className="new-stat">{latest}</span>}
              {this.state.oldValue === true && <span className="old-stat">{previous}</span>}
            </span>
          </div> : ''}   */}
        </div> 
        
          {/* {this.props.inProgress === true
          ?
            <Image className="spinner-img" src="spinner" />
          :
            ""
        } */}
            </>
  }
        {childNodes.length > 0 && (((childrenLength.length > 0 || !this.props.isRedirect) && this.state.isOpen) || (["Environment", "Datasource"].includes(type) && !(this.state.isChanged) && this.props.isSearchHappened)) && (
          <ul className={ulClassName}>
            {childNodes.map(({ id, title, childNodes, type, isOpen, isShow,metrics,customMetrics,latest,previous,error,firstDataset,is_disabled }) => (
              isShow || !this.props.isRedirect || (["Environment", "Datasource"].includes(type) && this.props.isSearchHappened && !(this.state.isChanged)) ? <Node key={title}
                title={title}
                id={id}
                changeData={this.props.changeData}
                isSearchHappened={this.props.isSearchHappened}
                isTreeSearch={this.props.isTreeSearch}
                envName={this.state.envName}
                envId={this.state.envId}
                isRedirect={this.props.isRedirect}
                highlightedType={this.state.highlightedType}
                highlightedId={this.state.highlightedId}
                datasourceName={this.state.datasourceName}
                datasetName={this.state.datasetName}
                attributeName={this.state.attributeName}
                datasourceId={this.state.datasourceId}
                datasetId={this.state.datasetId}
                attributeId={this.state.attributeId}
                childNodes={childNodes !== undefined ? Object.values(childNodes) : []}
                type={type} 
                isOpen={firstDataset || this.state.isOpen}  // Ensure firstDataset is always open
                subString={this.props.subString}
                isShow={isShow}
                isNodeHasActions = {this.props.isNodeHasActions}
                showCustomCheckbox={this.state.showCustomCheckbox}
                isChanged={this.state.isChanged}
                // isChecked={this.props.isChecked}  
                // handleCheckboxChange={this.props.handleCheckboxChange}
                // arrowIndicator={this.props.arrowIndicator}
                // newValue = {this.props.newValue}
                // oldValue = {this.props.oldValue}
                // latest ={latest}
                // previous={previous}
                is_disabled={is_disabled}
                // error = {error}
                // firstDataset={firstDataset}
                handleSaveWatchlistCheckboxChange ={this.props.handleSaveWatchlistCheckboxChange}
                checkedStates={this.props.checkedStates}
                // metrics={metrics}
                customMetrics={customMetrics}
                watchListOpen={this.props.watchListOpen}
                inProgress = {this.props.inProgress}



/> : ""
            ))}
          </ul>
        )}
      {this.state.noRunsToast && (
        <div style={{
          position: 'fixed',
          bottom: '24px',
          right: '24px',
          background: '#f64e60',
          color: '#fff',
          padding: '10px 18px',
          borderRadius: '6px',
          fontSize: '13px',
          fontWeight: 500,
          zIndex: 9999,
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8zm8-3.5a.5.5 0 01.5.5v4a.5.5 0 01-1 0V5a.5.5 0 01.5-.5zm0 7a.75.75 0 110-1.5.75.75 0 010 1.5z" fill="#fff"/>
          </svg>
          No runs found
        </div>
      )}
      </li>
    );
  }
}  
